
import FpuiInputCheckbox from './FpuiInputCheckbox'
import FpuiInputRadio from './FpuiInputRadio'
import FpuiInputTag from './FpuiInputTag'
import FpuiInputTags from './FpuiInputTags'
import FpuiInputText from './FpuiInputText'
import FpuiInputTextAddon from './FpuiInputTextAddon'
import FpuiInputSearch from './FpuiInputSearch'
import FpuiInputPassword from './FpuiInputPassword'
import FpuiInputTextarea from './FpuiInputTextarea'
import FpuiInputTextEditable from './FpuiInputTextEditable'
import FpuiInputSelect from './FpuiInputSelect'
import FpuiInputNumber from './FpuiInputNumber'
import FpuiInputStyle from './FpuiInputStyle'
import FpuiInputToggle from './FpuiInputToggle'
import FpuiInputImage from './FpuiInputImage'
import FpuiInputFileZone from './FpuiInputFileZone'
import FpuiDropdownList from './FpuiDropdownList'
import FpuiIconSelect from './FpuiIconSelect'
import MultiSelect from 'vue-multiselect'

export {
  FpuiInputText,
  FpuiInputTextAddon,
  FpuiInputSearch,
  FpuiInputPassword,
  FpuiInputTextarea,
  FpuiInputTextEditable,
  FpuiInputSelect,
  FpuiInputNumber,
  FpuiInputCheckbox,
  FpuiInputRadio,
  FpuiInputTag,
  FpuiInputTags,
  FpuiInputStyle,
  FpuiInputImage,
  FpuiInputToggle,
  FpuiInputFileZone,
  FpuiDropdownList,
  FpuiIconSelect,
  MultiSelect
}

export default {
  FpuiInputText,
  FpuiInputTextAddon,
  FpuiInputSearch,
  FpuiInputPassword,
  FpuiInputTextarea,
  FpuiInputTextEditable,
  FpuiInputSelect,
  FpuiInputNumber,
  FpuiInputCheckbox,
  FpuiInputRadio,
  FpuiInputTag,
  FpuiInputTags,
  FpuiInputStyle,
  FpuiInputImage,
  FpuiInputToggle,
  FpuiInputFileZone,
  FpuiDropdownList,
  FpuiIconSelect,
  MultiSelect
}
